import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/services/general.service';
import { CompleterService, CompleterData } from 'ng2-completer';
import { ScheduleService } from 'src/app/services/schedule.service';
import Swal from 'sweetalert2';
import { AgendaMedico2Component } from 'src/app/components/agenda-medico2/agenda-medico2.component';
import { EncriptacionService } from 'src/app/services/encriptacion.service';

@Component({
  selector: 'app-reserva-hora-cc',
  templateUrl: './reserva-hora-cc.component.html',
  styleUrls: ['./reserva-hora-cc.component.css']
})
export class ReservaHoraCcComponent implements OnInit {

  _title = 'Agenda Paciente';
  _subtitle = 'Reserva de hora';

  _usuario: any = {};
  hoursDay: any = {};
  daySelected: any = {};
  @ViewChild(AgendaMedico2Component) AGENDA_MEDICO: AgendaMedico2Component;
  data_appo: any = {};
  appointment_reason = '';
  beneficiary_list;
  beneficiary_selected;
  beneficiary_id;
  acompanante_list;
  acompanante_selected;
  acompanante_id;
  sub_speciality_id;
  id_consulta_reservada: string;

  doctorList: any = [];
  specialityList: any = [];
  availabilityDoctorHourList: any = [];

  showOptionMedical = true;
  showSuccessMessage: boolean;

  strDoctorName: string;
  subtitle: string;
  completerData: CompleterData;

  doctorSelected: any = {};
  hourSelected: any = {};

  steps: any = {
    searchDoctor: false,
    selectDate: false,
    completeForm: false,
    showSummary: false
  };

  titular_list: any[] = [];
  titular_selected: any = {};
  rut_titular: string;
  titulares: CompleterData;
  searchStrMain = '';
  tit_cargado = false;

  private lastSearchValue = '';
  private searchTimeout: any = null;
  private isSelectingTitular = false;

  constructor(
    public generalService: GeneralService,
    private completerService: CompleterService,
    public scheduleService: ScheduleService,
    public router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.tit_cargado = false;

    this._usuario = new EncriptacionService().getUserInfo();

    if (this._usuario.typ_id != 7) {
      Swal.fire({
        icon: 'info',
        title: 'Acceso no autorizado',
        timer: 2000
      });
      setTimeout(() => this.router.navigate(['dashboard']), 2000);
    }

    this.showSuccessMessage = false;
    this.steps.searchDoctor = true;

    this.titulares = this.completerService.local([], 'nombre_completo,use_username', 'nombre_completo');
  }

 onTitularInputChange(valor: string) {
  const texto = (valor || '').trim();

  this.searchStrMain = valor || '';

  // Ignorar cambios internos del componente al seleccionar/autocompletar
  if (this.tit_cargado || this.isSelectingTitular) {
    return;
  }

  // Si el valor actual coincide con el titular ya seleccionado, no buscar de nuevo
  if (
    this.titular_selected &&
    this.titular_selected.nombre_completo &&
    texto === this.titular_selected.nombre_completo.trim()
  ) {
    return;
  }

  if (texto.length < 4) {
    this.lastSearchValue = '';
    this.titular_list = [];
    this.titulares = this.completerService.local([], 'nombre_completo,use_username', 'nombre_completo');
    this.titular_selected = {};
    return;
  }

  if (texto === this.lastSearchValue) {
    return;
  }

  clearTimeout(this.searchTimeout);
  this.searchTimeout = setTimeout(() => {
    this.lastSearchValue = texto;
    this.getTitulares(texto);
  }, 300);
}

changeTitular(event: any) {
  if (event && event.originalObject) {
    this.isSelectingTitular = true;
    this.titular_selected = event.originalObject;
    this.searchStrMain = event.originalObject.nombre_completo || '';

    setTimeout(() => {
      this.isSelectingTitular = false;
    }, 100);
  }
}

  getTitulares(valor: string) {
    this.generalService.postListarBeneficiarioMain(valor)
    //valor = al numero que se ingres en el input
      .then((results: any[]) => {
        this.titular_list = results || [];

        this.titular_list.forEach((tit: any) => {
          tit.nombre_completo =
            `${tit.use_name || ''} ${tit.use_paternal_surname || ''} ${tit.use_maternal_surname || ''} | ${tit.use_username || ''}`.trim();
        });

        this.titulares = this.completerService.local(
          [...this.titular_list],
          'nombre_completo,use_username',
          'nombre_completo'
        );
      })
      .catch(() => {
        this.titular_list = [];
        this.titulares = this.completerService.local([], 'nombre_completo,use_username', 'nombre_completo');

        Swal.fire({
          icon: 'warning',
          title: 'Error al cargar los beneficiarios.',
          timer: 2000
        });
      });
  }

  // changeTitular(event: any) {
  //   if (event && event.originalObject) {
  //     this.isSelectingTitular = true;
  //     this.titular_selected = event.originalObject;
  //     this.searchStrMain = event.originalObject.nombre_completo || '';
  //     setTimeout(() => this.isSelectingTitular = false, 0);
  //   }
  // }

  rutTitular() {
    if (!this.titular_selected || !this.titular_selected.use_username) {
      this.generalService.modalError('Debe ingresar un rut válido.', '');
      this.tit_cargado = false;
      this.beneficiary_selected = {};
      return;
    }

    this.rut_titular = this.titular_selected.use_username;
    this.beneficiary_selected = this.titular_selected;
    this.tit_cargado = true;
  }

  change() {
    this.tit_cargado = false;
    this.beneficiary_selected = {};
    this.titular_selected = {};
    this.searchStrMain = '';
    this.lastSearchValue = '';
    this.titular_list = [];
    this.titulares = this.completerService.local([], 'nombre_completo,use_username', 'nombre_completo');
  }
}